
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 127.862 127.862"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8CC63F","d":"M63.93 0l63.931 63.93-63.93 63.93L0 63.93z"}})])
          )
        }
      }
    